import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import remindersReducer from './slices/remindersSlice';
import reminderLogsReducer from './slices/reminderLogsSlice';
import notificationsReducer from './slices/notificationsSlice';
import workersReducer from './slices/workersSlice';
import todosReducer from './slices/todosSlice';
import todoTagsReducer from './slices/todoTagsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    reminders: remindersReducer,
    reminderLogs: reminderLogsReducer,
    notifications: notificationsReducer,
    workers: workersReducer,
    todos: todosReducer,
    todoTags: todoTagsReducer,
  },
});

export default store;
